import { render, staticRenderFns } from "./savingPermissions.vue?vue&type=template&id=50aacdbb"
import script from "./savingPermissions.vue?vue&type=script&lang=js"
export * from "./savingPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports